import React from 'react';
import Icon from './Icon';

// Clean placeholder for screens/features not yet wired (usually waiting on a PHP act).
// Avoids blank pages / silent dead clicks.
export default function ComingSoon({ title, note = 'המסך הזה יתווסף בקרוב.' }) {
    return (
        <div style={{ padding: 'var(--s-6)', direction: 'rtl', fontFamily: 'var(--font)' }}>
            {title && <h1 style={{ fontSize: 'var(--fs-title)', fontWeight: 'var(--fw-bold)', color: 'var(--text)', margin: '0 0 var(--s-5)' }}>{title}</h1>}
            <div style={{
                background: 'var(--surface)', border: '1px solid var(--border)', borderRadius: 'var(--r-lg)',
                boxShadow: 'var(--shadow-sm)', padding: 'var(--s-7)', textAlign: 'center', color: 'var(--text-muted)',
            }}>
                <div style={{ marginBottom: 'var(--s-3)', display: 'flex', justifyContent: 'center', color: 'var(--text-muted)' }}><Icon name="info" size={40} /></div>
                <p style={{ margin: 0, fontSize: 'var(--fs-body)' }}>{note}</p>
            </div>
        </div>
    );
}
